import { assignable } from "../assignable";
import { clone } from "../clone";
import { assign } from "../assign";

const secureKeys: (string | symbol)[] = [
	"__proto__",
	"constructor",
	"prototype",
];

/**
 * assign one key from one object to the target
 * @private
 * @param {Object} target Target object to assign to
 * @param {Object} source The object to assign value
 * @param {String|Symbol} key
 * no return value
 */
export function assignKey(
	target: Record<string | symbol, any>,
	source: Record<string | symbol, any>,
	key: string | symbol,
) {
	if (secureKeys.includes(key)) {
		// Ignore silently to avoid malicious construct prototype pollution
		return;
	}

	target[key] =
		!(key in target) || !assignable(source[key])
			? source[key]
			: assign(clone(target[key]), source[key]);
}
